import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Dropdown,
  Form,
  Button,
  Spinner,
  Table,
} from "react-bootstrap";
import bgimg from "../src/Assets/Images/bg-1.jpg";
import { getLatestBlock, getLatestTransaction } from "./Pages/ApiCall";
import { useEffect } from "react";
import { useState } from "react";
import HomeBlock from "./Pages/HomeBlock";
import axios from "axios";

import MainComponent from ".//Pages/MainComponent";
import { isElementOfType } from "react-dom/test-utils";

function Home() {
  const [Latestblock, setlatestblock] = useState(null);
  const [Latesttransaction, setlatesttransaction] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [noRecordError, setNoRecordError] = useState({
    noRecordError: "",
    isRecordFound: false,
  });
  const navigate = useNavigate();
  const URL = process.env.REACT_APP_API_URL;
  const [count, setcount] = useState(0);
  const fetchtransation = () => {
    getLatestTransaction()
      .then((latesttransation) => {
        setlatesttransaction(latesttransation?.data.data);
        setLoading(false);
      })
      .catch(() => {});
  };
  const fetchBlocks = () => {
    getLatestBlock()
      .then((blockResponse) => {
        setlatestblock(blockResponse?.data.data);
        setLoading(false);
      })
      .catch(() => {});
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchtransation();
      fetchBlocks();
    }, 2000);

    return () => clearInterval(intervalId);
  }, []);
  const fetchResults = async (search, endpoint, type) => {
    try {
      const response = await axios.get(endpoint);
      // setNoRecordError({noRecordError: '', isRecordFound: false})
      const data = response.data;
      const resultOption = (
        <li
          onClick={() => {
            setDropdownOptions([]);
            navigate(`${type}/${search}`);
            setSearchText("");
          }}
        >
          <div className="dropdown-heading">
            <span>
              [{type}] {search}
            </span>
          </div>
        </li>
      );
      setDropdownOptions([resultOption]);
    } catch (error) {
      setcount((temp) => temp + 1);
      setNoRecordError({
        noRecordError: "No record Found",
        isRecordFound: true,
      });
    }
  };

  useEffect(() => {
    if (count >= 3) {
      const resultOption = (
        <li>
          <div className="dropdown-heading">
            <span>No Record Found</span>
          </div>
        </li>
      );
      setDropdownOptions([resultOption]);
      setcount(0);
    }
  }, [count]);
  useEffect(() => {
    if (searchText && searchText.length > 0) {
      const accountEndpoint = URL + "/v1/account/" + searchText;
      const transactionEndpoint = URL + "/v1/transaction/" + searchText;
      const blockEndpoint = URL + "/v1/block/" + searchText;

      fetchResults(searchText, blockEndpoint, "block");
      fetchResults(searchText, accountEndpoint, "address");
      fetchResults(searchText, transactionEndpoint, "tx");
    }
  }, [searchText, navigate]);
  useEffect(() => {
    if (!searchText) setDropdownOptions([]);
  }, [dropdownOptions, searchText]);

  window.Navigateto = (tabName) => {
    navigate(tabName);
  };
  const handleSearchIconClick = () => {
    const validNumberRegex = /^\d+$/;
    const validAddressRegex = /^.{42}$/;
    if (searchText !== "") {
      if (validNumberRegex.test(searchText)) {
        navigate(`block/${searchText}`);
      } else if (validAddressRegex.test(searchText)) {
        navigate(`address/${searchText}`);
      } else {
        navigate(`tx/${searchText}`);
      }
      setSearchText("");
      setDropdownOptions([]);
    }
  };

  const searchhandel = (e) => {
    setSearchText(e.target.value.trim());
    // setDropdownOptions([]);
    // if (searchText.length < 0) {
    //   setSearchText("");
    //   setDropdownOptions("");
    // }
  };
  return (
    <>
      {/* Header */}
      <div className="header">
        <div className="header-inner">
          <div
            className="bg-layer"
            style={{ backgroundImage: `url(${bgimg})` }}
          ></div>
          <h1>AMG Chain</h1>
          <div className="main-search-panel">
            <Dropdown>
              <Dropdown.Toggle variant="success" id="dropdown-basic">
                <b>Search</b>
              </Dropdown.Toggle>
              {/* 
              <Dropdown.Menu>
                <Dropdown.Item href="#">All Filters</Dropdown.Item>
                <Dropdown.Item href="#">Address</Dropdown.Item>
                <Dropdown.Item href="#">Tokens</Dropdown.Item>
                <Dropdown.Item href="#">Txn Hash</Dropdown.Item>
                <Dropdown.Item href="#">Block</Dropdown.Item>
              </Dropdown.Menu> */}
            </Dropdown>
            <Form>
              <Form.Control
                type="text"
                placeholder="Search by Address/Txn Hash/Block"
                value={searchText}
                onChange={searchhandel}
              />
              {dropdownOptions.length > 0 && (
                <ul className="dropdown-list">{dropdownOptions}</ul>
              )}
              <Button
                onClick={handleSearchIconClick}
                disabled={searchText === ""}
              >
                <i className="fa fa-search"></i>
              </Button>
            </Form>
          </div>
        </div>
      </div>
      {/* Header */}
      <div className="main-inner">
        <div className="container-fluid">
          <Row>
            <Container>
              <Row>
                <Col xl="12" md="12">
                  <HomeBlock />
                </Col>
                <Col xl="6" md="12">
                  <MainComponent
                    data={Latestblock}
                    Heading={"Latest Blocks"}
                    button={"View All Blocks"}
                    Route={"/blocks"}
                    // onClick={navigateToBlock}
                    // onItemClick={navigateToBlock}
                  />
                </Col>
                <Col xl="6" md="12">
                  <MainComponent
                    data={Latesttransaction}
                    Heading={"Latest Tansactions"}
                    button={"View All Transactions"}
                    Route={"/txs"}
                  />
                </Col>
              </Row>
            </Container>
          </Row>
        </div>
      </div>
    </>
  );
}
export default Home;
